export class HssResponse<T> {
  private _body!: T | null;
  private _isSuccess!: boolean;
  private _apiCallType!: string;
  private _message!: string;
  private _infoCode!: string;

  get body(): T | null {
    return this._body;
  }

  set body(value: T | null) {
    this._body = value;
  }

  get isSuccess(): boolean {
    return this._isSuccess;
  }

  set isSuccess(value: boolean) {
    this._isSuccess = value;
  }

  get apiCallType(): string {
    return this._apiCallType;
  }

  set apiCallType(value: string) {
    this._apiCallType = value;
  }

  get message(): string {
    return this._message;
  }

  set message(value: string) {
    this._message = value;
  }

  get infoCode(): string {
    return this._infoCode;
  }

  set infoCode(value: string) {
    this._infoCode = value;
  }
}
